import { render, staticRenderFns } from "./CommunityChoiceSidebar.vue?vue&type=template&id=73159760"
import script from "./CommunityChoiceSidebar.vue?vue&type=script&lang=js"
export * from "./CommunityChoiceSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports